// Unit constants for Carbon Intensity measurements - MUST be defined first
export const UNIT_GCOMMICOMM_LHV = "gCO2e/MJ_LHV";
export const UNIT_GCOMMICOMM_MJ = "gCO2e/MJ";
export const UNIT_EMISSIONKOMMIKOMMI = "(KTPA)";
export const UNIT_MTPA = "MTPA";
export const UNIT_MMBTU = "MMBTU";
export const UNIT_MWH = "MWh";
export const UNIT_KBBL = "KBBL";
export const UNIT_PJ = "PJ";
export const UNIT_TBTU = "TBTU";
export const UNIT_SLMT = "SLMT";

// KPI/Column Header Constants
export const KPI_OPERATED_SCOPE_MTPA = `Operated Scope 1&2 (${UNIT_MTPA})`;
export const KPI_EQUITY_SCOPE_MTPA = `Equity Scope 1&2 (${UNIT_MTPA})`;
export const KPI_NET_ABSOLUTE_EMISSIONS_MTPA = `Net Absolute Emissions (${UNIT_MTPA})`;
export const KPI_NCI_IMPACT = `NCI Impact (${UNIT_GCOMMICOMM_MJ})`;
export const KPI_VOLUME_WEIGHTED_AVG_CI_KTPA = `Volume-weighted Avg Carbon Intensity (KTPA)`;
export const KPI_SCOPE3_CAT11_KTPA = `Scope 3 Category 11 Emission (KTPA)`;

// Special Row Constants for Data Tables
export const TABLE_ROW_TOTAL_VOLUME = "Total Volume";
export const TABLE_ROW_CARBON_CREDIT = "Carbon Credits (Carbon Reduction), KTPA";

// Region Constants
export const REGION_AMERICAS = "Americas";
export const REGION_ASIA = "Asia";
export const REGION_EUROPE = "Europe";
export const REGION_AFRICA = "Africa";
export const REGION_AUSTRALIA = "Australia";
export const REGION_GLOBAL = "Global";

// Country Constants
export const COUNTRY_CANADA = "Canada";
export const COUNTRY_BRUNEI = "Brunei";
export const COUNTRY_EGYPT = "Egypt";

// Commodity/Energy Source Constants
export const COMMODITY_PIPELINE_GAS = "Pipeline Gas";
export const COMMODITY_LNG = "LNG";
export const COMMODITY_RNG = "RNG";
export const COMMODITY_WIND = "Wind";
export const COMMODITY_SOLAR = "Solar";
export const COMMODITY_HYDROPOWER = "Hydropower";
export const COMMODITY_BIOMASS = "Biomass";
export const COMMODITY_GEOTHERMAL = "Geothermal";
export const COMMODITY_GRID = "Grid";
export const COMMODITY_OIL = "Oil";
export const COMMODITY_COAL = "Coal";
export const COMMODITY_GAS_FIRED_GENERATION = "Gas Fired Generation";

// Asset/Supply Type Constants
export const ASSET_SHELL = "Shell Asset";
export const ASSET_THIRD_PARTY = "Third Party";
export const ASSET_IG = "IG Asset";

// Australia-based Locations
export const AUSTRALIA_GORGON = "Australia - Gorgon";
export const AUSTRALIA_NWS = "Australia - NWS";
export const AUSTRALIA_PRELUDE = "Australia - Prelude";
export const AUSTRALIA_QGC = "Australia - QGC";

export const NET_ABS_EMISSION_SCOPE_PEAK_ANNUAL_EMISSION =
  "Net Absolute Emissions Scope 1,2 & 3 (Peak annual emissions)";
export const NET_ABS_EMISSION_SCOPE_TOTAL_EMISSION =
  "Net Absolute Emissions Scope 1,2 & 3 (Total emissions)";
export const MARGIN_TO_CARBON_RATIO_AVG = "Margin to Carbon Ratio (Average)";
export const DEAL_TERM = "Deal Term";
export const TOTAL_CO2_EMISSION = "Total CO2 emissions";
export const AVG_CARBON_INT = "Avg Carbon Intensity**";
// New KPI labels for Step 03 Carbon KPIs table
export const VOLUME_WEIGHTED_AVG_CARBON_INT = `Volume-weighted Avg Carbon Intensity ${UNIT_GCOMMICOMM_MJ}`;
export const SCOPE3_CAT11_EMISSION = `Scope 3 Category 11 Emission ${UNIT_EMISSIONKOMMIKOMMI}`;
export const MARGIN_TO_CO2_RATIO = "Margin to CO2 ratio";
export const EQUITY_SCOPE_CARBON_PEAK_ANNUAL_EMISSION =
  "Equity Scope 1&2 Carbon (Peak annual emissions)";
export const OPERATED_SCOPE = KPI_OPERATED_SCOPE_MTPA;
export const EQUITY_SCOPE = KPI_EQUITY_SCOPE_MTPA;
export const NET_ABSOLUTE_EMISSIONS = KPI_NET_ABSOLUTE_EMISSIONS_MTPA;
export const ASSET_SCOPE1_CI = "Scope 1 Combustion Carbon Intensity";
export const TECH_SOURCE_COLUMN = "Tech Source, ";
export const TECH_SOURCE_COLUMN_POWER = "Power Output from Tech Source, ";
export const PRODUCTS_COLUMN = "Products, ";
export const GVCET = "Gas value chain emissions-Thermal";
export const FUEL_CO2E = "Fuel CO2e";
export const LNG_NCF_CI = "LNG NCF intensity";
export const GAS_END_USE_CF_CI = "Gas end-use intensity";
export const MMBTU = UNIT_MMBTU;
export const MWH = UNIT_MWH;
export const KBBL = UNIT_KBBL;
export const TECHSOURCE_TWH = "Tech Source TWh";
export const PJ = UNIT_PJ;
export const NATURAL_GAS = "Natural Gas";
export const POWER = "Power";
export const PIPELINE_GAS = COMMODITY_PIPELINE_GAS;
export const AMERICAS = REGION_AMERICAS;
export const ASIA = REGION_ASIA;
export const AUSTRALIA = REGION_AUSTRALIA;
export const EUROPE = REGION_EUROPE;
export const GLOBAL = REGION_GLOBAL;
export const AFRICA = REGION_AFRICA;
export const WIND = COMMODITY_WIND;
export const SOLAR = COMMODITY_SOLAR;
export const HYDROPOWER = COMMODITY_HYDROPOWER;
export const BIOMASS = COMMODITY_BIOMASS;
export const GEOTHERMAL = COMMODITY_GEOTHERMAL;
export const OIL = COMMODITY_OIL;
export const COAL = COMMODITY_COAL;
export const GRID = COMMODITY_GRID;
export const GAS_FIRED_GENERATION = COMMODITY_GAS_FIRED_GENERATION;
export const DR_POWER_OTHERS = "DR Power Others";
export const SLMT = UNIT_SLMT;
export const SHELL_ASSET = ASSET_SHELL;
export const THIRD_PARTY = ASSET_THIRD_PARTY;
export const TBTU = UNIT_TBTU;
export const FEEDBACK_LINK = "https://forms.office.com/e/PWgg8Ln0WV";
export const HELP_LINK =
  "https://eu001-sp.shell.com/:w:/r/sites/AAAAA0900/Documents/STSE_PRJ2154223_Carbon%20Management%20Framework/CPM/Product%20Management/User%20Instructions/Carbon%20KPI%20Calculator.docx?d=w4f90f8a01f43453d8bac52182abfb90c&csf=1&web=1&e=GaKYqs";
export const FEEDBACK_LABEL = "Feedback";
export const HELP_LABEL = "Help";
export const DOWNLOAD_DEALS = "Download Deals";
export const DELETE_DEALS = "Delete Deals";
export const UPDATE_DEALS = "Update Deals in Crabon Dashboard";
export const SERVICE_FAILURE_CONSOLE_LOG = "Get output KPI service failure =>";
export const API_VERSION_ONE = "api/v1/";
export const BROWNFIELD = "BROWNFIELD";
export const GREENFIELD = "GREENFIELD";
export const LNG = COMMODITY_LNG;
export const RNG = COMMODITY_RNG;
export const COUNTRY = "Country";
export const COUNTRY_ASSET_OF_SUPPLY = "Country/Asset of Supply";
export const TYPE_OF_SUPPLY = "Type of Supply";
export const MESSAGES = {
  peakAnnualEmmision: {
    below50KtaMessage:
      "There are <strong>no specific Carbon requirements</strong> (Equity Scope 1&2 <0.050 mtCO2e; Carbon Significant threshold). Proceed without Carbon Functional Approval",
    between50To200KTAmessage:
      "This opportunity is <strong>Carbon Significant</strong>  (Equity Scope 1&2 (Peak Annual Emissions) > 0.050 mtCO2e and < 0.200 mtCO2e)",
    above200KTAmessage:
      "This opportunity is <strong>Carbon Critical</strong> (Equity Scope 1&2 (Peak Annual Emissions) > 0.200 mtCO2e)",
  },
  performanceStandard: {
    carbonCritical: {
      contactInfo:
        "Please contact the following for Carbon Functional Support: Moene, Robert GSNL-PTS/ES robert.moene@shell.com",
      assetBrownfield: {
        efficiencyAbove57Info:
          "Opportunity <strong>Does Meet</strong> Performance Standard (Brownfield >=58% LHV Efficiency)",
        efficiencyBelow58Info:
          "Opportunity <strong>Does Not Meet</strong> Performance Standard (Brownfield <58% LHV efficiency)",
      },
      assetGreenfield: {
        efficiencyAbove59Info:
          "Opportunity <strong>Does Meet</strong> Performance Standard (Greenfield >=60% LHV Efficiency)",
        efficiencyBelow60Info:
          "Opportunity <strong>Does Not Meet</strong> Performance Standard (Greenfield <60% LHV efficiency)",
      },
    },
    carbonSignificant: {
      contactInfo:
        "Please contact the following for Carbon Functional Support: Cray, David GSCA-PTS/ED David.Cray@shell.com",
      assetBrownfield: {
        efficiencyAbove39Info:
          "Opportunity <strong>Does Meet</strong> Performance Standard (Brownfield >=40% LHV Efficiency)",
        efficiencyBelow40Info:
          "Opportunity <strong>Does Not Meet</strong> Performance Standard (Brownfield <40% LHV efficiency)",
      },
      assetGreenfield: {
        efficiencyAbove41Info:
          "Opportunity <strong>Does Meet</strong> Performance Standard (Greenfield >=42% LHV Efficiency)",
        efficiencyBelow42Info:
          "Opportunity <strong>Does Not Meet</strong> Performance Standard (Greenfield  <42% LHV efficiency)",
      },
    },
  },
  operatingModel: {
    sovOrNov: "Performance Standard is <strong>Mandatory</strong> (equity investment)",
    lease: "Performance Standard is <strong>Best Practice</strong> (lease)",
  },
};
export const POWER_PERFORMANCE_STANDARD = "Power Performance Standard";
export const POWER_PERFORMANCE_STANDARD_DESCRIPTION =
  "Power Performance Standard evaluation is a control framework requirement for Equity Investments and a best practice for Leases.";
export const LAST_UPDATE_TIMESTAMP = "LAST_UPDATE_TIMESTAMP";
export const FOOT_NOTE =
  "For Pipeline gas commodity selection, Value Chain Carbon Intensity unit of measure is gCO2e/MJ and for Power commodity it is tCO2e/MWh.";
export const GROSS_MARGIN_MESSAGE =
  "Gross Margin: the total margin (used in Economics) across all the years for the deal/project";
export const KPI_SUMMARY = "KPI Summary";
export const UNIT_FOR_MEASURE_CONVERTER = "UOM and FX rates converter";
export const UNIT_FOR_MEASURE_CONVERTER_LINK =
  "https://apps.powerapps.com/play/e/af5c03df-f395-405c-a93f-87a7408adb36/a/2fecfd69-772f-411e-9f07-9150929a8013?tenantId=db1e96a8-a3da-442a-930b-235cac24cd5c&hint=6f70da29-d4b2-4be0-9c80-1be6671e1805&sourcetime=1718012337324";
export const contactPerson = [
  { email: "David.Cray@shell.com", name: "David Cray" },
  { email: "robert.moene@shell.com", name: "Robert Moene" },
];
export const CARBON_SIGNIFICANT = "carbonSignificant";
export const CARBON_CRITICAL = "carbonCritical";
export const ASSET_BROWNFIELD = "assetBrownfield";
export const ASSET_GREENFIELD = "assetGreenfield";
export const MTCO2E = "mtCO2e";
export const MCR_AVG_UOM = "$/tCO2e";
export const FETCH_ERROR = "Error fetching data";
export const DEAL_MOVED = "Deal moved to carbon dashboard";
export const DEAL_REMOVED = "Deal removed from carbon dashboard";
export const DEAL_DELETED = "Deals deleted successfully";
export const SELECT_DEALS = "Please select atleast one deal to delete.";

// Region-Country Mapping (Static - to be replaced by API when ready)
export const REGION_COUNTRY_MAPPING: Record<string, string[]> = {
  Global: ["Global"],
  Asia: [
    "Hong Kong",
    "Malaysia",
    "Thailand",
    "Oman",
    "Pakistan",
    "Philippines",
    "Singapore",
    "India",
    "Indonesia",
    "UAE",
    "China",
  ],
  Europe: [
    "Italy",
    "France",
    "Turkey",
    "United Kingdom",
    "Bulgaria",
    "Czech Republic",
    "Hungary",
    "Poland",
    "Slovakia",
    "Austria",
    "Germany",
    "Switzerland",
    "Netherlands",
    "Luxembourg",
    "Belgium",
  ],
  Americas: ["USA", "Canada", "Mexico"],
  Africa: ["Africa"],
};
export const allowedCommoditiesForSEandDRevp = ["pipelinegas", "rng", "power"];
export const allowedCommoditesForSlmtRevp = ["lng", "biolng", "cclng"];

export const techSourcePermitted = [
  "wind",
  "solar",
  "hydropower",
  "biomass",
  "geothermal",
  "oil",
  "coal",
  "grid",
];

// Intensity Feedstock data for T&S Products - Static (from Excel specification)
// Units: gCO2e/MJ_LHV
// Note: Region-specific values; 'Default' is used when region doesn't match
export const TS_PRODUCTS_INTENSITY_FEEDSTOCK: Record<
  string,
  Record<string, { value: number; unit: string }>
> = {
  Gasoline: {
    Americas: { value: 83.5, unit: UNIT_GCOMMICOMM_LHV },
    Africa: { value: 86.4, unit: UNIT_GCOMMICOMM_LHV },
    Asia: { value: 85, unit: UNIT_GCOMMICOMM_LHV },
    Europe: { value: 83.5, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 84.1, unit: UNIT_GCOMMICOMM_LHV },
  },
  Ethanol: {
    Brazil: { value: 32.4, unit: UNIT_GCOMMICOMM_LHV },
    Argentina: { value: 45.6, unit: UNIT_GCOMMICOMM_LHV },
    Belgium: { value: 57.3, unit: UNIT_GCOMMICOMM_LHV },
    Canada: { value: 45.6, unit: UNIT_GCOMMICOMM_LHV },
    Denmark: { value: 56.8, unit: UNIT_GCOMMICOMM_LHV },
    France: { value: 40.6, unit: UNIT_GCOMMICOMM_LHV },
    India: { value: 30.9, unit: UNIT_GCOMMICOMM_LHV },
    Philippines: { value: 39, unit: UNIT_GCOMMICOMM_LHV },
    SIETCo: { value: 45.6, unit: UNIT_GCOMMICOMM_LHV },
    STR: { value: 43.9, unit: UNIT_GCOMMICOMM_LHV },
    Thailand: { value: 33.6, unit: UNIT_GCOMMICOMM_LHV },
    Turkey: { value: 44.5, unit: UNIT_GCOMMICOMM_LHV },
    "United States": { value: 45.4, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 39.7, unit: UNIT_GCOMMICOMM_LHV },
  },
  Diesel: {
    Americas: { value: 85.8, unit: UNIT_GCOMMICOMM_LHV },
    Africa: { value: 88.3, unit: UNIT_GCOMMICOMM_LHV },
    Asia: { value: 86.9, unit: UNIT_GCOMMICOMM_LHV },
    Europe: { value: 85.3, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 86, unit: UNIT_GCOMMICOMM_LHV },
  },
  HVO: {
    Average: { value: 27.6, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 27.6, unit: UNIT_GCOMMICOMM_LHV },
  },
  FAME: {
    Argentina: { value: 18.7, unit: UNIT_GCOMMICOMM_LHV },
    Brazil: { value: 21, unit: UNIT_GCOMMICOMM_LHV },
    Canada: { value: 18.4, unit: UNIT_GCOMMICOMM_LHV },
    Denmark: { value: 64.2, unit: UNIT_GCOMMICOMM_LHV },
    "Eco Oils": { value: 64.2, unit: UNIT_GCOMMICOMM_LHV },
    France: { value: 32.8, unit: UNIT_GCOMMICOMM_LHV },
    "Hong Kong": { value: 16.1, unit: UNIT_GCOMMICOMM_LHV },
    Indonesia: { value: 58.6, unit: UNIT_GCOMMICOMM_LHV },
    Malaysia: { value: 58.6, unit: UNIT_GCOMMICOMM_LHV },
    Philippines: { value: 19.6, unit: UNIT_GCOMMICOMM_LHV },
    Poland: { value: 42.1, unit: UNIT_GCOMMICOMM_LHV },
    SIETCo: { value: 16.2, unit: UNIT_GCOMMICOMM_LHV },
    STR: { value: 27.8, unit: UNIT_GCOMMICOMM_LHV },
    SZTP: { value: 16.1, unit: UNIT_GCOMMICOMM_LHV },
    Thailand: { value: 58.6, unit: UNIT_GCOMMICOMM_LHV },
    Turkey: { value: 21.3, unit: UNIT_GCOMMICOMM_LHV },
    "United Kingdom": { value: 27.3, unit: UNIT_GCOMMICOMM_LHV },
    "United States": { value: 18, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 27.7, unit: UNIT_GCOMMICOMM_LHV },
  },
  LPG: {
    Americas: { value: 75.7, unit: UNIT_GCOMMICOMM_LHV },
    Africa: { value: 78.2, unit: UNIT_GCOMMICOMM_LHV },
    Asia: { value: 76.7, unit: UNIT_GCOMMICOMM_LHV },
    Europe: { value: 75.2, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 75.8, unit: UNIT_GCOMMICOMM_LHV },
  },
  "Fuel Oil": {
    Americas: { value: 91.5, unit: UNIT_GCOMMICOMM_LHV },
    Africa: { value: 94, unit: UNIT_GCOMMICOMM_LHV },
    Asia: { value: 92.6, unit: UNIT_GCOMMICOMM_LHV },
    Europe: { value: 91, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 91.7, unit: UNIT_GCOMMICOMM_LHV },
  },
  Kerosene: {
    Americas: { value: 85, unit: UNIT_GCOMMICOMM_LHV },
    Africa: { value: 87.5, unit: UNIT_GCOMMICOMM_LHV },
    Asia: { value: 86.1, unit: UNIT_GCOMMICOMM_LHV },
    Europe: { value: 84.5, unit: UNIT_GCOMMICOMM_LHV },
    Default: { value: 85.2, unit: UNIT_GCOMMICOMM_LHV },
  },
};

// Scope 3 CAT11 (Tank to Wheel) CI Factors for T&S Products - Static (from Excel specification)
// Units: gCO2e/MJ_LHV
export const TS_PRODUCTS_CAT11_FACTORS: Record<
  string,
  { pathway: string; productType: string; value: number; unit: string }
> = {
  Gasoline: { pathway: "Oil", productType: "Gasoline", value: 71.46, unit: UNIT_GCOMMICOMM_LHV },
  Diesel: { pathway: "Oil", productType: "Diesel/Gasoil", value: 73.33, unit: UNIT_GCOMMICOMM_LHV },
  Kerosene: { pathway: "Oil", productType: "Kerosene", value: 72.54, unit: UNIT_GCOMMICOMM_LHV },
  "Fuel Oil": { pathway: "Oil", productType: "Fuel Oil", value: 79.02, unit: UNIT_GCOMMICOMM_LHV },
  LPG: { pathway: "Oil", productType: "LPG", value: 62.94, unit: UNIT_GCOMMICOMM_LHV },
  Ethanol: { pathway: "Biofuels", productType: "Ethanol", value: 0.55, unit: UNIT_GCOMMICOMM_LHV },
  HVO: { pathway: "Biofuels", productType: "HVO", value: 0.24, unit: UNIT_GCOMMICOMM_LHV },
  FAME: { pathway: "Biofuels", productType: "FAME", value: 1.18, unit: UNIT_GCOMMICOMM_LHV },
};

// Type of Supply options for SLMT - Static, to be replaced by API when ready
// TODO: TYPE_OF_SUPPLY_OPTIONS is static. Replace with API call once backend is ready
// API endpoint should return list of available Type of Supply options (e.g., Shell Asset, Third Party, IG Asset)
export const TYPE_OF_SUPPLY_OPTIONS = [
  { value: ASSET_SHELL, label: ASSET_SHELL },
  { value: ASSET_THIRD_PARTY, label: ASSET_THIRD_PARTY },
  { value: ASSET_IG, label: ASSET_IG },
];

// SLMT Commodity options - Static, to be replaced by API when ready
// TODO: SLMT_COMMODITY_OPTIONS is static. Replace with API call once backend is ready
// API endpoint should return list of commodities available for SLMT (LNG, BioLNG, CCLNG)
export const SLMT_COMMODITY_OPTIONS = [
  { value: "LNG", label: "LNG" },
  { value: "BioLNG", label: "BioLNG" },
  { value: "CCLNG", label: "CCLNG" },
];

// Type of Supply to Country/Asset mapping for SLMT - Static, to be replaced by API when ready
// TODO: TYPE_OF_SUPPLY_COUNTRY_MAPPING is static. Replace with API call once backend is ready
// API endpoint should accept typeOfSupply and return list of available countries/assets for that type
// Example: GET /api/slmt/countries?typeOfSupply=IG Asset
export const TYPE_OF_SUPPLY_COUNTRY_MAPPING: Record<string, string[]> = {
  "Shell Asset": [
    AUSTRALIA_GORGON,
    AUSTRALIA_NWS,
    AUSTRALIA_PRELUDE,
    AUSTRALIA_QGC,
    COUNTRY_BRUNEI,
    COUNTRY_EGYPT,
    "Nigeria",
    "Oman",
    "Peru",
    "Qatar - Qatar",
    "Qatar - NFS",
    "Qatar - NFE",
    "UAE",
    "Trinidad",
    COUNTRY_CANADA,
    "Mashreq",
  ],
  "Third Party": [
    "Algeria",
    "Angola",
    "Argentina",
    "Australia",
    "Belgium",
    "Brazil",
    "Brunei",
    "Cameroon",
    "Canada",
    "China",
    "Egypt",
    "Equatorial Guinea",
    "France",
    "Germany",
    "India",
    "Indonesia",
    "Italy",
    "Japan",
    "Malaysia",
    "Mozambique",
    "Netherlands",
    "Nigeria",
    "Norway",
    "Oman",
    "Papua New Guinea",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Russia",
    "Singapore",
    "South Korea",
    "Spain",
    "Trinidad and Tobago",
    "Turkey",
    "UAE",
    "United Kingdom",
    "United States of America",
    "Yemen",
    "Other",
  ],
  "IG Asset": [AUSTRALIA_GORGON, "Global LNG", "Qatar - NFE"],
};

// SLMT Carbon Intensities (gCO2e/MJ) - Static data from specification
// Structure: [Type of Supply][Commodity][Country/Asset][Year]
// TODO: SLMT_CARBON_INTENSITIES is static data. Replace with API call once backend is ready
// API endpoint should accept: typeOfSupply, commodity, country/asset, and return carbon intensity data for all years
export const SLMT_CARBON_INTENSITIES: Record<
  string,
  Record<string, Record<string, Record<number, number>>>
> = {
  "IG Asset": {
    LNG: {
      [AUSTRALIA_GORGON]: {
        2026: 68.4,
        2027: 68.4,
        2028: 68.4,
        2029: 68.4,
        2030: 68.4,
        2031: 68.4,
        2032: 68.4,
        2033: 68.4,
        2034: 68.4,
        2035: 68.4,
      },
      [AUSTRALIA_NWS]: {
        2026: 67.5,
        2027: 67.5,
        2028: 67.5,
        2029: 67.5,
        2030: 67.5,
        2031: 67.5,
        2032: 67.5,
        2033: 67.5,
        2034: 67.5,
        2035: 67.5,
      },
      [AUSTRALIA_PRELUDE]: {
        2026: 72.1,
        2027: 72.1,
        2028: 72.1,
        2029: 72.1,
        2030: 72.1,
        2031: 72.1,
        2032: 72.1,
        2033: 72.1,
        2034: 72.1,
        2035: 72.1,
      },
      [AUSTRALIA_QGC]: {
        2026: 68.4,
        2027: 68.4,
        2028: 68.4,
        2029: 68.4,
        2030: 68.4,
        2031: 68.4,
        2032: 68.4,
        2033: 68.4,
        2034: 68.4,
        2035: 68.4,
      },
      Brunei: {
        2026: 71.0,
        2027: 71.0,
        2028: 71.0,
        2029: 71.0,
        2030: 71.0,
        2031: 71.0,
        2032: 71.0,
        2033: 71.0,
        2034: 71.0,
        2035: 71.0,
      },
      Egypt: {
        2026: 84.4,
        2027: 84.4,
        2028: 84.4,
        2029: 84.4,
        2030: 84.4,
        2031: 84.4,
        2032: 84.4,
        2033: 84.4,
        2034: 84.4,
        2035: 84.4,
      },
      Nigeria: {
        2026: 72.4,
        2027: 72.4,
        2028: 72.4,
        2029: 72.4,
        2030: 72.4,
        2031: 72.4,
        2032: 72.4,
        2033: 72.4,
        2034: 72.4,
        2035: 72.4,
      },
      Oman: {
        2026: 73.6,
        2027: 73.6,
        2028: 73.6,
        2029: 73.6,
        2030: 73.6,
        2031: 73.6,
        2032: 73.6,
        2033: 73.6,
        2034: 73.6,
        2035: 73.6,
      },
      Peru: {
        2026: 71.2,
        2027: 71.2,
        2028: 71.2,
        2029: 71.2,
        2030: 71.2,
        2031: 71.2,
        2032: 71.2,
        2033: 71.2,
        2034: 71.2,
        2035: 71.2,
      },
      "Qatar - NFE": {
        2026: 56.5,
        2027: 63.49,
        2028: 62.3,
        2029: 62.3,
        2030: 62.3,
        2031: 62.3,
        2032: 62.3,
        2033: 62.3,
        2034: 62.3,
        2035: 62.3,
      },
      "Qatar - Qatar": {
        2026: 66.9,
        2027: 66.9,
        2028: 66.9,
        2029: 66.9,
        2030: 66.9,
        2031: 66.9,
        2032: 66.9,
        2033: 66.9,
        2034: 66.9,
        2035: 66.9,
      },
      "Qatar - NFS": {
        2026: 56.5,
        2027: 56.5,
        2028: 63.12,
        2029: 62.52,
        2030: 62.52,
        2031: 62.52,
        2032: 62.52,
        2033: 62.52,
        2034: 62.52,
        2035: 62.52,
      },
      UAE: {
        2026: 56.5,
        2027: 56.5,
        2028: 56.5,
        2029: 60.89,
        2030: 60.89,
        2031: 60.89,
        2032: 60.89,
        2033: 60.89,
        2034: 60.89,
        2035: 60.89,
      },
      Trinidad: {
        2026: 70.1,
        2027: 70.1,
        2028: 70.1,
        2029: 70.1,
        2030: 70.1,
        2031: 70.1,
        2032: 70.1,
        2033: 70.1,
        2034: 70.1,
        2035: 70.1,
      },
      Canada: {
        2026: 60.11,
        2027: 60.12,
        2028: 60.13,
        2029: 60.1,
        2030: 60.11,
        2031: 60.07,
        2032: 61.98,
        2033: 60.88,
        2034: 60.81,
        2035: 60.8,
      },
      Mashreq: {
        2026: 69.7,
        2027: 69.7,
        2028: 69.7,
        2029: 69.7,
        2030: 69.3,
        2031: 63.7,
        2032: 63.2,
        2033: 63.2,
        2034: 63.2,
        2035: 63.3,
      },
    },
    BioLNG: {
      [AUSTRALIA_GORGON]: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      [AUSTRALIA_NWS]: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      [AUSTRALIA_PRELUDE]: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      [AUSTRALIA_QGC]: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Brunei: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Egypt: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Nigeria: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Oman: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Peru: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      "Qatar - NFE": {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      "Qatar - Qatar": {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      "Qatar - NFS": {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      UAE: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Trinidad: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Canada: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
      Mashreq: {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
    },
    CCLNG: {
      [AUSTRALIA_GORGON]: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      [AUSTRALIA_NWS]: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      [AUSTRALIA_PRELUDE]: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      [AUSTRALIA_QGC]: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Brunei: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Egypt: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Nigeria: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Oman: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Peru: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      "Qatar - NFE": {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      "Qatar - Qatar": {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      "Qatar - NFS": {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      UAE: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Trinidad: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Canada: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
      Mashreq: {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
    },
  },
  "3P/unknown": {
    LNG: {
      "Global/Any": {
        2026: 69.9,
        2027: 69.9,
        2028: 69.9,
        2029: 69.9,
        2030: 69.9,
        2031: 69.9,
        2032: 69.9,
        2033: 69.9,
        2034: 69.9,
        2035: 69.9,
      },
    },
    BioLNG: {
      "Global/Any": {
        2026: 16.1,
        2027: 16.1,
        2028: 16.1,
        2029: 16.1,
        2030: 16.1,
        2031: 16.1,
        2032: 16.1,
        2033: 16.1,
        2034: 16.1,
        2035: 16.1,
      },
    },
    CCLNG: {
      "Global/Any": {
        2026: 0.0,
        2027: 0.0,
        2028: 0.0,
        2029: 0.0,
        2030: 0.0,
        2031: 0.0,
        2032: 0.0,
        2033: 0.0,
        2034: 0.0,
        2035: 0.0,
      },
    },
  },
};

// TODO: SLMT_CONVERSION_FACTORS are static. Replace with API call once backend is ready
// API should return conversion factors based on commodity type
// SLMT Conversion Factors
export const SLMT_CONVERSION_FACTORS = {
  TBTU_HHV_TO_MT_LNG: 52.69,
  LNG_KG_TO_MJ_LHV: 50.1,
};
